/**
 * Array Pool Utilities
 * Provides object pooling for efficient array operations
 */

class SimpleArrayPool {
  constructor() {
    this.pool = [];
    this.maxSize = 20;
    this.created_count = 0;
    this.reused_count = 0;
  }

  /**
   * Get an array from the pool or create a new one
   * @param {number} size - Minimum size needed for the array
   * @returns {Array} Reusable array
   */
  getArray(size = 250) {
    let array = this.pool.pop();

    if (array) {
      array.length = 0;
      this.reused_count++;
    } else {
      array = new Array(size);
      this.created_count++;
    }

    return array;
  }

  /**
   * @param {Array} array - Array to return to pool
   */
  releaseArray(array) {
    if (this.pool.length < this.maxSize && Array.isArray(array)) {
      array.length = 0;
      this.pool.push(array);
    }
  }

  /**
   * @returns {Object} Pool statistics
   */
  getStats() {
    return {
      pool_size: this.pool.length,
      max_size: this.maxSize,
      created_count: this.created_count,
      reused_count: this.reused_count,
      reuse_ratio: this.created_count > 0 ? (this.reused_count / (this.created_count + this.reused_count) * 100).toFixed(1) : 0
    };
  }

  clear() {
    this.pool.length = 0;
  }
}

// Singleton pool instance for shared use
export const arrayPool = new SimpleArrayPool();
export default SimpleArrayPool;